import React, {useEffect, useState} from 'react'
import {Header} from '../../components/Header/Header'
import {SectionOne} from './SectionOne'
import {SectionThree} from './SectionThree'
import {SectionTwo} from './SectionTwo'
import {SectionFour} from "./SectionFour";
import {serverConn} from "../../API/apiRequest";
import ReactGA from 'react-ga'

interface Props {
}

export const Home: React.FC<Props> = () => {
    const [companies, setcompanies] = useState<{
        companyName: string,
        id: string,
        picture: string,
    }[]>();
    useEffect(() => {
        ReactGA.pageview(window.location.pathname)
        
        serverConn.get(`/topcompany`).then((res) => {
            if(res.status === 200) {
                setcompanies(res.data.companies)
            }
        }).catch(e=>{
            console.log(e)
        })
    }, [])
    return (
            <>
                <Header/>
                <SectionOne/>
                {companies && companies.length > 0 && (<SectionFour companies={companies}/>)
                }
                <SectionTwo/>
                <SectionThree/>


                {/*<ContactusSection/>*/}
            </>
    )
}